import { NotificationList } from "../../services/notifications/notifications-interface";

export const actionTypes = {
  SET_NOTIFICATION_LIST: "SET_NOTIFICATION_LIST",
};

const setNotificationList = (payload: NotificationList) => ({
  type: actionTypes.SET_NOTIFICATION_LIST,
  payload,
});

export default {
  setNotificationList,
};
